import { PipeTransform, Pipe } from '@angular/core';

@Pipe({
  name: 'normalize',
})
export class NormalisePipe implements PipeTransform {
  transform(value: any) {
    return value
      .normalize('NFC')
      .trim()
      .replace(/[^a-z0-9]/gi, '')
      .toLowerCase();
  }
}
